/* eslint-disable jsx-a11y/alt-text */
import { createColumnHelper } from "@tanstack/react-table";
import { indexer } from "../../../utils/utils";
import { formatDateTime, formatPrice } from "../../../utils";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useTaxInvoices } from "../../../api/tax-invoice/use-tax-invoice";
import Table from "../../../components/ui/Table/Table";
import TaxInvoiceModal from "./TaxInvoiceModal";

import { Pagination } from "../../../components/ui/Table/Pagination/Pagination";
import Modal from "../../../components/ui/Modal/Modal";
import { SaveIcon } from "../../../assets/icons";

const columnHelper = createColumnHelper();

const columns = (page, pageSize, total) => {
  return [
    columnHelper.accessor((row) => row, {
      header: "번호",
      cell: (info) => {
        const index = info.cell.row.index;
        const indexing = indexer(page, pageSize, total);

        return <div>{indexing(index)}</div>;
      },
    }),

    columnHelper.accessor((row) => row, {
      header: "주문번호(신청일시)",
      cell: (info) => {
        const row = info.row.original;
        return (
          <div>
            <p className="text-secondary-blue underline">{row?.orderNo}</p>(
            {formatDateTime(row?.orderAt)})
          </div>
        );
      },
    }),

    columnHelper.accessor((row) => row, {
      header: "상품명",
      cell: (info) => {
        const row = info.row.original;
        const lineItems = row?.orderSummary?.lineItems ?? [];
        const mainProductName = lineItems[0]?.product?.name;
        const otherProductNames =
          lineItems.slice(1).map((item) => item.product.name).length > 0
            ? `외 ${
                lineItems.slice(1).map((item) => item.product.name).length
              }건`
            : "";
        return (
          <div>
            {mainProductName ? mainProductName : "-"}{" "}
            {otherProductNames ? otherProductNames : ""}
          </div>
        );
      },
    }),

    columnHelper.accessor((row) => row, {
      header: "주문자(담당자)이메일",
      cell: (info) => {
        const row = info.row.original;
        return <div>{row?.hospital?.email}</div>;
      },
    }),

    columnHelper.accessor((row) => row, {
      header: "사업자등록번호(요청)",
      cell: (info) => {
        const row = info.row.original;
        return <div>{row?.bankHolderBizNo}</div>;
      },
    }),

    columnHelper.accessor((row) => row, {
      header: "대표자/담당자 연락처",
      cell: (info) => {
        const row = info.row.original;
        return (
          <div>
            {row?.hospital?.ceoPhone}
            <br />
            {row?.hospital?.managerPhone}
          </div>
        );
      },
    }),

    columnHelper.accessor((row) => row, {
      header: "결제금액",
      cell: (info) => {
        const row = info.row.original;
        const paidPrice = row?.paidPrice ?? 0;
        const deliveryFee = row?.deliveryFee ?? 0;
        return <div>{formatPrice(paidPrice - deliveryFee)}</div>;
      },
    }),

    columnHelper.display({
      header: "신청처리 현황",
      id: "publicationStatus",
      cell: (info) => <ButtonPublicationActions row={info.row.original} />,
    }),

    columnHelper.display({
      header: "자세히보기",
      id: "detail",
      cell: ButtonActions,
    }),
  ];
};

function publicationStatusButtonLabel(row) {
  const isIssued = row?.taxInvoiceSummary?.isIssued;
  return isIssued ? "발행완료" : "발행대기";
}

function ButtonPublicationActions({ row }) {
  const isIssued = row?.taxInvoiceSummary?.isIssued;

  return (
    <Modal
      hasCancel={false}
      hasClose
      hasSubmit={false}
      padding="p-0"
      closable
      maxWidth="max-w-[37rem]"
      description={<TaxInvoiceModal order={row} />}
    >
      <button
        type="button"
        className={`w-16 text-center p-[1px] border rounded-[4px] ${
          isIssued
            ? "border-[#cccccc] text-[#999999] bg-[#f5f5f5] cursor-not-allowed"
            : "border-secondary-blue text-secondary-blue"
        }`}
        disabled={isIssued}
      >
        {publicationStatusButtonLabel(row)}
      </button>
    </Modal>
  );
}

function ButtonActions(props) {
  const id = props.row.original.id;
  const navigate = useNavigate();
  return (
    <button
      type="button"
      onClick={() => navigate(`${id}`)}
      className="w-10 p-[1px] border border-[#cccccc] rounded-[4px] text-[#333333]"
    >
      상세
    </button>
  );
}

export function TaxInvoicesTable(props) {
  const { filter } = props;
  // const { isEmpty, getDataTableProps } = useProductCodeManagementList(filter);
  const { isEmpty, getDataTableProps } = useTaxInvoices();
  const currentPage = getDataTableProps().pagination?.pageIndex + 1;
  const pageSize = getDataTableProps().pagination?.pageSize;
  const totalData = getDataTableProps().total;

  const onSave = async () => {
    // await fetchTaxInvoicesDownload().then((response) => {
    //   const url = window.URL.createObjectURL(new Blob([response]));
    //   const link = document.createElement("a");
    //   link.href = url;
    //   link.setAttribute("download", `product-code-${Date.now()}.xlsx`);
    //   document.body.appendChild(link);
    //   link.click();
    // });
  };

  return (
    <>
      {/* {isEmpty ? (
        <>
          <div className="text-title-grey flex justify-center py-20 w-full">
            등록된 내역이 없습니다.
          </div>
        </>
      ) : ( */}
      <>
        <Table
          hasPageSizeFilter={false}
          hasSort={false}
          hasPagination={false}
          onSave={onSave}
          columns={columns(currentPage, pageSize, totalData)}
          {...getDataTableProps()}
        />
        <div className="flex justify-end mt-1 text-disable-black">
          ※ 세금계산서 연동 시점 : 무통장입금 결제 회원의 주문이 최종적으로
          '구매확정'되어 완료된 경우에 한하여, [발행대기] 버튼이 활성화됩니다.
        </div>
        <div className="mt-8 flex justify-center overflow-auto">
          <Pagination
          //   total={table.getPageCount()}
          //   page={table.getState().pagination.pageIndex}
          //   isDisabledPrevPage={!table.getCanPreviousPage()}
          //   isDisabledNextPage={!table.getCanNextPage()}
          //   onPrevClick={() => table.previousPage()}
          //   onNextClick={() => table.nextPage()}
          //   onChange={(nextPage) => table.setPageIndex(nextPage)}
          //   onLastClick={() => table.setPageIndex(table.getPageCount())}
          //   onFirstClick={() => table.setPageIndex(0)}
          />
          <div className="flex-none">
            <Modal
              hasCancel={false}
              description="다운로드 되었습니다."
              onSubmit={() => {}}
            >
              <button
                // onClick={onSave}
                className="px-[10px] py-[5px] border border-[#cccccc] rounded-[4px] text-[#333333]"
              >
                <div className="flex items-center gap-2">
                  <SaveIcon />
                  엑셀 저장
                </div>
              </button>
            </Modal>
          </div>
        </div>
      </>
      {/* )} */}
    </>
  );
}
